import { render, staticRenderFns } from "./DashboardTransSummary.vue?vue&type=template&id=c3a4b184&"
import script from "./DashboardTransSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardTransSummary.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTransSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports